import { BaseCategory, BaseCategoryEdit } from './base-category.model';

export class InformationCategory extends BaseCategory {}

export class InformationCategoryEdit extends BaseCategoryEdit {}
